import { Component } from '@angular/core';

@Component({
  selector: 'fin-form-fields',
  styleUrls: ['form-fields.component.scss'],
  templateUrl: 'form-fields.component.html',
})
export class FormFieldsComponent {}
